import { render, staticRenderFns } from "./testQuestionBank.vue?vue&type=template&id=0221db7c&scoped=true&"
import script from "./testQuestionBank.vue?vue&type=script&lang=js&"
export * from "./testQuestionBank.vue?vue&type=script&lang=js&"
import style0 from "./testQuestionBank.vue?vue&type=style&index=0&id=0221db7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221db7c",
  null
  
)

export default component.exports